module.exports = __webpack_public_path__ + "img/forum_thumbnail-600x450.b69f94b7.jpg";